import styled from "styled-components";
import {parseSize} from "../../../common/generic-react.functions.js";
export const IconContainer = styled.span.withConfig({
  displayName: "iconstyles__IconContainer",
  componentId: "sc-1cwr0ml-0"
})(["", " ", " ", " font-size:", ";height:", ";width:", ";svg{font-size:", ";height:", ";width:", ";}"], {
  display: "inline-flex",
  alignSelf: "center",
  alignItems: "center",
  justifyContent: "center",
  verticalAlign: "middle",
  transitionProperty: "opacity",
  transitionTimingFunction: "cubic-bezier(0.4, 0, 0.2, 1)",
  transitionDuration: "150ms"
}, ({
  clickable
}) => clickable && {
  cursor: "pointer"
}, ({
  hidden
}) => hidden && {
  display: "none"
}, ({
  size
}) => parseSize(size), ({
  size
}) => parseSize(size), ({
  size
}) => parseSize(size), ({
  size
}) => parseSize(size), ({
  size
}) => parseSize(size), ({
  size
}) => parseSize(size));
